import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Grid2,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Header from "../Header";
import Footer from "../Footer";
import passwordimg from "../../assets/images/passwordimg.svg";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import useRequests from "../../utils/useRequests";
import Snackbars from "../../utils/Snackbars";
import Password from "../../assets/images//password.png";
import HidePassword from "../../assets/images/hidePassword.png";

const Changepassword = () => {
  const navigate = useNavigate();
  const { postRequest } = useRequests();
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    new_confirm_password: "",
  });
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [showPassword, setShowPassword] = useState(false);
  const [newShowPassword, setNewShowPassword] = useState(false);
  const [newConfirmShowPassword, setNewConfirmShowPassword] = useState(false);

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      old_password: "",
      new_password: "",
      new_confirm_password: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required("Old password is required"),
      new_password: Yup.string()
        .required("New password is required")
        .min(8, "Password must be at least 8 characters long!")
        .max(20, "Password must not exceed 20 characters!"),
      new_confirm_password: Yup.string()
        .required("Confirm new password")
        .oneOf([Yup.ref("new_password"), null], "Passwords must match!"),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      let submit1 = document.getElementById("submit1");
      submit1.disabled = true;
      submit1.textContent = "Processing...";

      if (formData.new_password !== formData.new_confirm_password) {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "New Password and Confirm Password do not match.",
        }));
        resetAlertData();
        return;
      }
      try {
        const jsonpar = JSON.stringify({
          old_password: values.old_password,
          new_password: values.new_password,
          new_confirm_password: values.new_confirm_password,
        });

        const res = await postRequest("profile-change-password", jsonpar);

        if (res && res.code === 200) {
          setFormData({
            old_password: "",
            new_password: "",
            new_confirm_password: "",
          });
          values.old_password = "";
          values.new_password = "";
          values.new_confirm_password = "";

          setAlertData({
            variant: "success",
            message: "Password updated successfully!",
          });
          resetAlertData();
        } else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "error",
            message: res.message || "Failed to update password.",
          }));
          resetAlertData();
        }
        submit1.disabled = false;
        submit1.textContent = " Update Password";
      } catch (error) {
        console.error("Error: ", error);

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "An error occurred while updating the password.",
        }));
        resetAlertData();
      }
    },
  });

  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className="center-App" container direction="column">
        <Header name="Change Password" />
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <Box
          sx={{
            padding: "15px 15px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          <div container spacing={2}>
            <div item xs={12}>
              <form className="loginForm">
                <div className="position-relative password-field">
                  <img
                    src={passwordimg}
                    alt="Logo"
                    width={24}
                    className="textboxLefticon"
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    placeholder="Old Password"
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    name="old_password"
                    className={`form-control ${
                      validation1.touched.old_password &&
                      validation1.errors.old_password
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation1.values.old_password || ""}
                    // onChange={(e) => setEmail(e.target.value)}
                    onChange={validation1.handleChange}
                    onBlur={validation1.handleBlur}
                    invalid={
                      validation1.touched.old_password &&
                      validation1.errors.old_password
                        ? true
                        : false
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            style={{ marginRight: "0px" }}
                          >
                            <img
                              className="password-hide-show"
                              src={showPassword ? Password : HidePassword}
                              alt="Toggle Password"
                              width={24}
                              height={24}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {validation1.touched.old_password &&
                  validation1.errors.old_password ? (
                    <div className="invalid-feedback">
                      {validation1.errors.old_password}
                    </div>
                  ) : null}
                </div>
                <div className="position-relative password-field">
                  <img
                    src={passwordimg}
                    alt="Logo"
                    width={24}
                    className="textboxLefticon"
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    placeholder="New Password"
                    autoComplete="off"
                    type={newShowPassword ? "text" : "password"}
                    name="new_password"
                    className={`form-control ${
                      validation1.touched.new_password &&
                      validation1.errors.new_password
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation1.values.new_password || ""}
                    // onChange={(e) => setEmail(e.target.value)}
                    onChange={validation1.handleChange}
                    onBlur={validation1.handleBlur}
                    invalid={
                      validation1.touched.new_password &&
                      validation1.errors.new_password
                        ? true
                        : false
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setNewShowPassword(!newShowPassword)}
                            edge="end"
                            style={{ marginRight: "0px" }}
                          >
                            <img
                              className="password-hide-show"
                              src={newShowPassword ? Password : HidePassword}
                              alt="Toggle Password"
                              width={24}
                              height={24}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {validation1.touched.new_password &&
                  validation1.errors.new_password ? (
                    <div className="invalid-feedback">
                      {validation1.errors.new_password}
                    </div>
                  ) : null}
                </div>
                <div className="position-relative password-field">
                  <img
                    src={passwordimg}
                    alt="Logo"
                    width={24}
                    className="textboxLefticon"
                  />
                  <TextField
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    placeholder="Confirm New Password"
                    autoComplete="off"
                    type={newConfirmShowPassword ? "text" : "password"}
                    name="new_confirm_password"
                    className={`form-control ${
                      validation1.touched.new_confirm_password &&
                      validation1.errors.new_confirm_password
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation1.values.new_confirm_password || ""}
                    onChange={validation1.handleChange}
                    onBlur={validation1.handleBlur}
                    invalid={
                      validation1.touched.new_confirm_password &&
                      validation1.errors.new_confirm_password
                        ? true
                        : false
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setNewConfirmShowPassword(!newConfirmShowPassword)
                            }
                            edge="end"
                            style={{ marginRight: "0px" }}
                          >
                            <img
                              className="password-hide-show"
                              src={
                                newConfirmShowPassword ? Password : HidePassword
                              }
                              alt="Toggle Password"
                              width={24}
                              height={24}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    // style={{borderColor:'red'}}
                  />
                  {validation1.touched.new_confirm_password &&
                  validation1.errors.new_confirm_password ? (
                    <div className="invalid-feedback">
                      {validation1.errors.new_confirm_password}
                    </div>
                  ) : null}
                </div>
                <Grid2 className="button-bottom fullWidth mt-3" fullWidth>
                  <Button
                    className="btn-common"
                    variant="contained"
                    color="primary"
                    fullWidth
                    id="submit1"
                    onClick={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                    }}
                  >
                    {"Update Password"}
                  </Button>
                  <Link to={"/profile"}>
                    <Button
                      className="btn-common-border"
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ marginTop: 2 }}
                    >
                      Edit Profile
                    </Button>
                  </Link>
                </Grid2>
              </form>
            </div>
          </div>
        </Box>
        <Footer />
      </div>
    </Box>
  );
};

export default Changepassword;
